export var CARD_SIZE_SMALL = 0;
export var CARD_SIZE_MEDIUM = 1;
export var CARD_SIZE_LARGE = 2;
//# sourceMappingURL=card-sizes.js.map